import React from 'react';
import { connect } from 'react-redux';
import Container from 'xgimi-ui/Container';
import { Button } from 'xgimi-ui';
import s from './.module.scss';
import images from '../../../../assets/images';

import StoreComponent, { mapStateToProps } from '../../../../appComponents/Store';

interface Props {}
interface State{}

/**
 * 查看历史反馈中间跳转页
 */
class Component extends StoreComponent<Props, State> {
  constructor(props: Props) {
    super(props, { languageKey: 'page.feedback', titleKey: 'gotoHistory' });
  }
  render():React.ReactNode {
    return (
      <Container className={s.container} isMobile={true}>
        <div className={s.content}>
          <img src={images.moreFeedbackBg} alt="引导图" />
          <Button
            color="#2479FF"
            onClick={() => window.open('weixin://dl/business/?t=ZpG5U5UrK2g')}
            classes={{ root: s.button }}
          >前往极米 care+
          </Button>
        </div>
      </Container>
    );
  }
}

export default connect(mapStateToProps)(Component);
